import {initFormRecaptcha} from '../helpers/recaptcha.js';

(() => {
    document.addEventListener('scrollToTopForm', function () {
        const element = document.querySelector('#form-test');
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    });

    document.addEventListener('scrollToResult', function () {
        const element = document.querySelector('#form-result');
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    });


    document.addEventListener('livewire:initialized', () => {
        Livewire.on('resetQuestions', (direction) => {
            if (direction === 'next') {
                document.querySelectorAll('[x-data]').forEach(el => {
                    if (el.__x) {
                        el.__x.getUnobservedData().selectedAnswer = null;
                    }
                });
                document.querySelectorAll('input[type="radio"]').forEach(radio => {
                    radio.checked = false;
                });
            }
        });
    });

    document.addEventListener('livewire:load', () => {
        Livewire.hook('message.processed', (message, component) => {
            document.querySelectorAll('[x-data]').forEach(el => {
                if (el.__x) {
                    const selectedAnswer = el.__x.getUnobservedData().selectedAnswer;
                    if (selectedAnswer !== null) {
                        el.querySelector(`input[type="radio"][value="${selectedAnswer}"]`).checked = true;
                    }
                }
            });
        });
    });

    document.addEventListener('DOMContentLoaded', initFormRecaptcha);
})();
